import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center justify-center gap-2">
    {[1, 2].map(i => (
      <div key={i} className="flex-1 h-12 bg-zinc-200 dark:bg-zinc-700 rounded p-1.5 flex flex-col gap-1">
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 bg-zinc-300 dark:bg-zinc-600 rounded-full" />
          <div className="w-6 h-1 bg-zinc-300 dark:bg-zinc-600 rounded" />
        </div>
        <div className="w-full h-1 bg-zinc-300 dark:bg-zinc-600 rounded" />
      </div>
    ))}
  </div>
);

export default Thumbnail;
